import { render, staticRenderFns } from "./CaricamentoOrdine.vue?vue&type=template&id=2f7670c0&scoped=true"
import script from "./CaricamentoOrdine.vue?vue&type=script&lang=js"
export * from "./CaricamentoOrdine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7670c0",
  null
  
)

export default component.exports